import { TwitchUser } from 'types';
import api from 'services/api';

export type UsersResponse = {
  data: TwitchUser[];
};

export type GetStreamKeyResponse = {
  data: Array<{ stream_key: string }>;
};

const requests = {
  getBroadcasterId: async () => {
    const {
      data: { data: users = [] }
    } = await api.instances.twitch.get<UsersResponse>('/users');

    const broadcasterId = users[0].id;

    return broadcasterId;
  },
  getStreamKey: async ({ broadcasterId }: { broadcasterId: string }) => {
    const {
      data: { data: streamKeys }
    } = await api.instances.twitch.get<GetStreamKeyResponse>('/streams/key', {
      params: {
        broadcaster_id: broadcasterId
      }
    });

    const streamKey = streamKeys[0].stream_key;

    return streamKey;
  }
};

export default requests;
